module.exports = __webpack_public_path__ + "static/media/what-are-healthy-food.c67bc5ab.png";